import { Guide, PageHandle, Section } from '../logic/Guide'

type TableOfContentsProps = {
    guide: Guide
    current: PageHandle
    isPrint?: boolean
    onNavigate: (handle: PageHandle) => void
}

const renderSection = (section: Section, current: PageHandle, onNavigate: (handle: PageHandle) => void, isPrint: boolean) => {
    return <>
        {section.title}
        <ul>
            {section.pages.map(page =>
                (section.key == current.section && page.key == current.page) || isPrint ?
                <li className="active" key={page.key}>{page.title}</li> : 
                <li key={page.key}><a href="#" onClick={() => onNavigate({ section: section.key, page: page.key} )}>{page.title}</a></li>
            )}
        </ul>
    </>
}

const body = ({ guide, onNavigate, current, isPrint}: TableOfContentsProps) => (
    <ul>
        {guide.sections.map(section => <li className="section" key={section.key}>{renderSection(section, current, onNavigate, !!isPrint)} </li>)}            
    </ul>
)

const TableOfContents = (props: TableOfContentsProps) => {
    if(props.isPrint) {
        return <>
            <h1>Table of contents</h1>
            {body(props)}
        </>
    }

    return <div className="toc">{body(props)}</div>
}

export default TableOfContents